import axios from 'axios';
import list from '@/utils/list.js'

export default {

    mapColor(unionId) {
        const colors = [
            'pink',
            'cyan',
            'orange',
            'purple',
            'indigo',
            'deep-orange',
            'blue',
            'green',
            'teal',
            'light-green',
            'lime',
            'light-blue',
            'brown',
            'deep-purple',
            'yellow',
            'amber',
            'blue-grey'
        ]
        const colorIndex = unionId.substring('UNION'.length) % colors.length
         return colors[colorIndex] + ' lighten-3'
     },

    unionAsScenario(union) {
        const unifiedElements = union.scenarios.flatMap(scenario => scenario.elements)
        return {
            id: union.id,
            elements: unifiedElements.filter((item, index, self) => self.findIndex(t => t.id === item.id) === index)
        }
    },

    findCompatibleScenariosUnion(projectId, unionId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/compatible-scenarios/${unionId}`);
    },

    findCompatibleScenarios(projectId, page, pageSize) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/compatible-scenarios?pageSize=${pageSize}&page=${page - 1}&sort=lastModifiedDate,desc`);
    },

    createCompatibleScenariosUnion(projectId, scenarioIds) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/compatible-scenarios`, scenarioIds);
    },

    updateCompatibleScenariosUnion(projectId, unionId, scenarioIds) {
        return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/compatible-scenarios/${unionId}`, scenarioIds);
    },

    deleteCompatibleScenariosUnion(projectId, unionId) {
        return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/compatible-scenarios/${unionId}`);
    },

    findMinimalScenarios(projectId, page, pageSize) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios?only-minimals=true&pageSize=${pageSize}&page=${page - 1}`)
    },

    createMinimalScenario(projectId, elementsIds) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios`, { elements: elementsIds })
    },

    updateScenario(projectId, scenario) {
        // const scenarioRequest = JSON.parse(JSON.stringify(scenario))
        // scenarioRequest.elements = scenarioRequest.elements.map(elt => { return elt.id})
        const scenarioRequest = {
            elements: scenario.elements.map(elt => { return elt.id})
        }
        return axios.put(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenario.id}`, scenarioRequest)
    },

    deleteMinimalScenario(projectId, scenarioId) {
        return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/scenarios/${scenarioId}`)
    },

    markAsNoMoreExtendable(projectId, scenario) {
        return this.updateScenario(projectId, {
            ...scenario,
            extend: 'false',
            elements: this.convertElements(scenario.elements)
        });
    },

    convertElements(elements) {
        return elements.map(element => ({elementId: element.id}));
    },

    getAllPreferences(projectId) {
        return axios.get(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences`);
    },

    createPreferences(projectId, preferences) {
        return axios.post(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences`,
            preferences);
    },

    deleteScenarioPreference(projectId, preferenceId) {
        return axios.delete(`${process.env.VUE_APP_RAISON_API_URL}projects/${projectId}/decision-policy/preferences/${preferenceId}`);
    },


    getAllScenarios(preferences) {
        let allScenarios = preferences.map(pref => pref.scenario);
        return list.removeDuplicateById(allScenarios);
    },
    getAllDescendants(parentScenario, allScenarios) {
        if(!parentScenario.nextLevel || parentScenario.nextLevel.length === 0) {
            return [];
        }
        // Direct descendants
        let descendants = allScenarios.filter(sce => parentScenario.nextLevel.includes(sce.id));
        // sub descendants
        parentScenario.nextLevel.forEach(scenarioId => {
            let descendant = allScenarios.find(sce => sce.id === scenarioId);
            if(descendant) {
                descendants.push(...this.getAllDescendants(descendant, allScenarios));
            }
        });
        return descendants;
    },

    getWigo(preference, beliefMode) {
        return beliefMode ? preference.wigoBelief : preference.wigo;
    },

    getLogo(preference, beliefMode) {
        return beliefMode ? preference.logoBelief : preference.logo;
    },

    optionsKey(options) {
        return options
            ?.map(option => option.id)
            .sort()
            .join('-') ?? '';
    },

    wigoKey(preference, beliefMode) {
        let wigo = this.getWigo(preference, beliefMode);
        return this.optionsKey(wigo);
    },

    logoKey(preference, beliefMode) {
        let logo = this.getLogo(preference, beliefMode);
        return this.optionsKey(logo);
    },

    discriminateWinningOptions(projectId, preference) {
        const winningOptions = preference.wigo;
        const scenarioElements = preference.scenario.elements;
        const newMinimalScenario = {
            id: '$scenarioRef1',
            name: 'discriminating minimal scenario',
            level: 1,
            elements: [...scenarioElements],
            extend: 'true',
        };
        const preferences = winningOptions.map(wigo => {
            const pref = {
                name: 'discriminating preference',
                scenario: newMinimalScenario,
                wigo: [wigo],
                previousPreferences: [ preference.id ],
            };
            return pref;
        });
        return this.createPreferences(projectId, preferences);
    },

    isMinimalScenario(scenario) {
      return scenario.level === 1;
    },

    isDiscriminatePreference(preference) {
      return this.isMinimalScenario(preference.scenario) && preference.previousPreferences.length > 0;
    },

    isMinimalPreference(preference, beliefMode, allowDiscriminatePreferences = false) {
      return this.isMinimalScenario(preference.scenario)
        && (allowDiscriminatePreferences || !this.isDiscriminatePreference(preference))
        && (beliefMode ? this.isBeliefPreference(preference) : this.isOptionPreference(preference));
    },

    isBeliefPreference(preference) {
      return preference.wigoBelief?.length > 0;
    },

    isOptionPreference(preference) {
      return preference.wigo?.length > 0;
    }
};